import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../shared/auth.guard';
import { SharedModule } from '../shared/shared.module';
import { AdminFormComponent } from './admin-form/admin-form.component';
import { AdminListComponent } from './admin-list/admin-list.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserResolver } from './user.resolver';
import { UserService } from './user.service';

const routes: Routes = [
  {
    path: '',
    data: { title: 'User' },
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      { path: 'profile', canActivate: [AuthGuard], component: UserProfileComponent, data: { title: 'Profile' } },
      { path: 'admins', canActivate: [AuthGuard], component: AdminListComponent, data: { title: 'Admins' } },
      {
        path: 'admins/form/add',
        canActivate: [AuthGuard],
        component: AdminFormComponent,
        data: { title: 'Admins' },
      },
      {
        path: 'admins/form/:id',
        resolve: { user: UserResolver },
        canActivate: [AuthGuard],
        component: AdminFormComponent,
        data: { title: 'Admins' },
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, RouterModule.forChild(routes), SharedModule],
  declarations: [UserProfileComponent, AdminListComponent, AdminFormComponent],
  exports: [RouterModule],
  providers: [UserService],
})
export class UserModule {}
